// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__FN82L","resendInfoText":"OnGoingPaymentBox_resendInfoText__YZ6EX"};